/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import Form from '../components/form';
import { EDIT_PRODUCT } from '../../../../queries/products/product';

export const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT_PRODUCT}
      update={async () => {
        await props.refetch();
      }}
    >
      {updateproducts => (
        <Form query_f={updateproducts} {...props} />
      )}
    </Mutation>

  );
};
